import { EnumRoutes } from '@/helpers/enums/routes.enum';
import type { RouteRecordRaw } from 'vue-router';

export const assessmentsRoutes: Array<RouteRecordRaw> = [
  {
    path: EnumRoutes.assessments.root.path,
    component: () => import('@/views/assessments/AssessmentLayout.vue'),
    meta: EnumRoutes.assessments.root.meta,

    children: [
      {
        path: '',
        name: EnumRoutes.assessments.root.name,
        component: () => import('@/views/assessments/AssessmentWelcome.vue'),
        meta: EnumRoutes.assessments.root.meta,
      },
      {
        path: EnumRoutes.assessments.assessmentsPage.path,
        name: EnumRoutes.assessments.assessmentsPage.name,
        component: () => import('@/views/assessments/SingleAssessmentPage.vue'),
      },
    ],
  },
];
